import { useEffect, useState } from "react";
import { js_utils } from "../utils/frfr-js-utils";
import { _zzsurvey_utils_questions_lib_obj, _zzsurvey_utils_quizBlueprint_to_initialAnswersState } from "../utils/zz/zz-zzsurvey-quiz-utils";
import Btn from "./Btn";
import FormError from "./FormError";
import FormFieldGenerator from "./FormFieldGenerator";
import FormGenerator from "./FormGenerator";
import JSDisplayValue from "./JSDisplayValue";


/*
answer: ';true;true;;', // odgovor moze biti ili CSV string sa ; (semicolon/tačka-zarez). kao separatorom. svak item koji je "true" se računa kao true stavljena kvačica, a sve ostalo se računa kao false.
answer: [, true, true,],

// NAPOMENA: ovo za NONE ignoriši, to još razmatram...
// "NONE": 'Ništa od navedenog', // ako je null onda ne postoji opcija 'Ništa od navedenog' a ako je string onda se prikazuje to polje. // u tabeli questions ovo polja nazvati opt_none
*/


const QUIZ_FIELD_NAME_PREFIX = 'question_name_';
const QUIZ_FIELD_NAME_PREFIX_EXTRA_ANSWER = 'extra_name_';


//
const _prepare_for_submit_answers = (state, is_anon) => {
  console.log('_prepare_for_submit_answers(state)', state, 'is_anonymous', is_anon);
  /*
  "answers": [
    {
        "question_id": 25,
        "question_type": "text",
        "answer": "Doing something you love."
    },
  */
  const prepared = {
    answers: [],
    is_anonymous: is_anon,
  };
  // prepared.answers = Object.keys(state).map((key, index) => {
  prepared.answers = state.map((singleAnswerState, index) => {
    // const key = item.question_id;
    // const question_id = key;
    // const singleAnswerState = state[question_id];
    const question_id = singleAnswerState.question_id;
    const question = singleAnswerState.q;
    let question_type = question.question_type;
    //
    // ---convert answers
    //
    // let answer = null;
    let outboxAnswer = null;
    if (question_type === "TEXT") { outboxAnswer = singleAnswerState.answer_main; }
    if (question_type === "YES_NO") { outboxAnswer = singleAnswerState.answer_main; }
    if (question_type === "STARS_5") { outboxAnswer = singleAnswerState.answer_main; }
    if (question_type === "SCALE_5") { // TODO OBRISATI VISAK // msg: "Answer must be a number for the scale question type."
      outboxAnswer = null;
      const n = Number.parseInt(singleAnswerState.answer_main);
      if (n === 0 || n > 0) {
        outboxAnswer = n;
      }
      /*
      {
          "title":"How would you describe your outlook on life?",
          "question_type":"scale",
          "opt_scale100":"Great",
          "opt_scale75":"Good",
          "opt_scale50":"Okay",
          "opt_scale25":"Bad",
          "opt_scale0":"Terrible"
      },
      */
      /*
       outboxAnswer.opt_scale100 = question.question_option_titles["100"];
       outboxAnswer.opt_scale75 = question.question_option_titles["75"];
       outboxAnswer.opt_scale50 = question.question_option_titles["50"];
       outboxAnswer.opt_scale25 = question.question_option_titles["25"];
       outboxAnswer.opt_scale0 = question.question_option_titles["0"];
       */
    }
    if (question_type === 'ABC') { // TODO proveriti da li je dobro da saljem malo slovo
      outboxAnswer = null;
      // if (js_utils.is_string_not_empty(question.question_option_titles["A"])) { question.question_option_titles["A"]; } else { }
      if (js_utils.is_string_not_empty(singleAnswerState.answer_main)) { // znaci da je odabrano slovo
        outboxAnswer = singleAnswerState.answer_main.toLowerCase();
      }
    }
    if (question_type === "CHECKLIST") { // TODO
      outboxAnswer = null;
      if (Array.isArray(singleAnswerState.answer_main)) {
        outboxAnswer = [];
        if (Array.isArray(question.question_checklist)) {
          question.question_checklist.forEach((title, index) => {
            if (typeof singleAnswerState.answer_main[index] === 'boolean') {
              outboxAnswer.push(singleAnswerState.answer_main[index]);
            } else {
              outboxAnswer.push(false);
            }
          });
        }
      }
    }
    //
    //
    question_type = question.question_type.toLowerCase();
    if (question_type === "yes_no") {
      question_type = "yesno";
    }
    if (question_type === "stars_5") {
      question_type = "stars";
    }
    if (question_type === "scale_5") {
      question_type = "scale";
    }
    //
    return {
      // ...outboxAnswer,
      question_id,
      // question_type: question.question_type,
      question_type: question_type,
      // answer: singleAnswerState.answer_main,
      answer: outboxAnswer,
      extra_answer: singleAnswerState.answer_extra,
    };
  });
  return prepared;
};


//
const AnswerText = (props) => {
  const {
    pack,
  } = props;
  const {
    index,
    question,
    title,
    name,
    value,
    handleChange,
    fieldValidationError,
    state,
    setState,
  } = pack;
  //
  return (
    <div className="zzsurvey__answer">
      <div className="zzsurvey__answer-abc">
        <FormFieldGenerator
          fieldDefinition={{
            "type": "textarea",
            "params": {
              "label": "",
              "name": name,
            }
          }}
          value={value}
          handleChange={handleChange}
          fieldError={fieldValidationError}
        />
      </div>
    </div>
  );
};
//
const AnswerYesNo = (props) => {
  const {
    pack,
  } = props;
  const {
    index,
    question,
    title,
    name,
    value,
    handleChange,
    fieldValidationError,
    state,
    setState,
  } = pack;
  //
  const _handleChange = (e) => {
    const name = e.target.name;
    const _value = e.target.value;
    let value = null;
    if (_value === "YES") {
      value = true;
    }
    if (_value === "NO") {
      value = false;
    }
    let virtual_e = {
      target: {
        name: name,
        value: value
      }
    }
    handleChange(virtual_e);
  };
  //
  let _value = null;
  if (value === true) {
    _value = "YES";
  }
  if (value === false) {
    _value = "NO";
  }
  //
  return (
    <div className="zzsurvey__answer">
      <div className="zzsurvey__answer-abc">
        <FormFieldGenerator
          fieldDefinition={{
            "type": "input_radio_group",
            "params": {
              "label": "",
              "name": name,
              "options": [
                { "title": "Da", "value": "YES" },
                { "title": "Ne", "value": "NO" },
              ],
              "outline": false,
              "extraclass": "novo-radios-row",
            }
          }}
          value={_value}
          handleChange={_handleChange}
          fieldError={fieldValidationError}
        />
      </div>
    </div>
  );
};
//
const AnswerAbc = (props) => {
  const {
    pack,
  } = props;
  const {
    index,
    question,
    title,
    name,
    value,
    handleChange,
    fieldValidationError,
    state,
    setState,
  } = pack;
  const {
    question_option_titles,
    // answer,
  } = question;
  //
  let _options = [];
  const abc_keys_string = "ABCDEFGHIJ";
  for (let i = 0; i < 10; i++) {
    const key = abc_keys_string[i];
    if (typeof question_option_titles[key] === 'string' && question_option_titles[key] !== '') {
      _options.push({ "title": (key + ') ' + question_option_titles[key]), "value": key });
      // _options.push({ "title": ('' + question_option_titles[key]), "value": key });
    }
  }
  //
  return (
    <div className="zzsurvey__answer">
      <div className="zzsurvey__answer-abc">
        <FormFieldGenerator
          fieldDefinition={{
            "type": "input_radio_group",
            "params": {
              "label": "",
              "name": name,
              "options": [
                ..._options
              ],
              "outline": false,
              "extraclass": "novo-radios-row222",
            }
          }}
          value={value}
          handleChange={handleChange}
          fieldError={fieldValidationError}
        />
      </div>
    </div>
  );
};
//
const AnswerScale5 = (props) => {
  const {
    pack,
  } = props;
  const {
    index,
    question,
    title,
    name,
    value,
    handleChange,
    fieldValidationError,
    state,
    setState,
  } = pack;
  const {
    question_option_titles,
    // answer,
  } = question;
  //
  return (
    <div className="zzsurvey__answer">
      <div className="zzsurvey__answer-abc">
        <FormFieldGenerator
          fieldDefinition={{
            "type": "input_radio_group",
            "params": {
              "valuetype": "number",
              "integer": true,
              "label": "",
              "name": name,
              "options": [
                { "title": question_option_titles["100"], "value": "100" },
                { "title": question_option_titles["75"], "value": "75" },
                { "title": question_option_titles["50"], "value": "50" },
                { "title": question_option_titles["25"], "value": "25" },
                { "title": question_option_titles["0"], "value": "0" },
              ],
              "outline": false,
              "extraclass": "novo-radios-row222",
            }
          }}
          value={'' + value}
          handleChange={handleChange}
          fieldError={fieldValidationError}
        />
      </div>
    </div>
  );
};
//
const Answer5Stars = (props) => {
  const {
    pack,
  } = props;
  const {
    index,
    question,
    title,
    name,
    value,
    handleChange,
    fieldValidationError,
    state,
    setState,
  } = pack;
  //
  const _handleClickStar = (_value) => {
    let virtual_e = {
      target: {
        name: name,
        value: _value
      }
    }
    handleChange(virtual_e);
  };
  //
  return (
    <div className="zzsurvey__answer">
      <div className="zzsurvey__answer-5stars">
        {/*
        <div className={"zzsurvey__star" + (value > 0 ? " active" : "")} onClick={(e) => { e.stopPropagation(); _handleClickStar(1) }}><i className="fa fa-star" aria-hidden="true"></i>
          <div className={"zzsurvey__star" + (value > 1 ? " active" : "")} onClick={(e) => { e.stopPropagation(); _handleClickStar(2) }}><i className="fa fa-star" aria-hidden="true"></i>
            <div className={"zzsurvey__star" + (value > 2 ? " active" : "")} onClick={(e) => { e.stopPropagation(); _handleClickStar(3) }}><i className="fa fa-star" aria-hidden="true"></i>
              <div className={"zzsurvey__star" + (value > 3 ? " active" : "")} onClick={(e) => { e.stopPropagation(); _handleClickStar(4) }}><i className="fa fa-star" aria-hidden="true"></i>
                <div className={"zzsurvey__star" + (value > 4 ? " active" : "")} onClick={(e) => { e.stopPropagation(); _handleClickStar(5) }}><i className="fa fa-star" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        */}
        <FormFieldGenerator
          fieldDefinition={{
            "type": "widget_stars5",
            "params": {
              "label": "",
              "name": name,
            }
          }}
          value={value}
          handleChange={handleChange}
          fieldError={fieldValidationError}
        />
      </div>
    </div>
  );
};
//
const AnswerChecklist = (props) => {
  const {
    pack,
  } = props;
  const {
    index,
    question,
    title,
    name,
    value,
    handleChange,
    fieldValidationError,
    state,
    setState,
    stateArr,
    setStateArr,
  } = pack;
  const {
    // title,
    question_checklist,
    // answer,
  } = question;
  //
  const checklist_arr = value;
  //
  const _handleChecklistChange = (e, index) => {
    const checked = e.target.checked;
    // const name = e.target.name;
    console.log('name', name, checked);
    /// const _checkboxIndex = name.split('_checkboxindex')[1];
    // console.log('_checkboxIndex', _checkboxIndex);
    //
    const updatedChecklistArr = checklist_arr.map((item, i) => {
      if (i === index) {
        // console.log('setStateArr checked', checked, 'i', i);
        return checked;
      }
      return item;
    });
    //
    let virtual_e = {
      target: {
        name: name,
        // value: _value,
        value: updatedChecklistArr,
      }
    }
    handleChange(virtual_e);
  };
  //
  return (
    <div className="zzsurvey__answer">
      {/*
      <JSDisplayValue val={question_checklist} />
      <JSDisplayValue val={answer} />
      <JSDisplayValue val={checklist_arr} />
      */}
      <div className="zzsurvey__answer-checklist">
        {
          question_checklist.map((question_checklist_title, index) => {
            const val = checklist_arr[index]; // TODO
            const _name = name + "_checklist_item_" + index;
            // TODO fieldError={fieldValidationError}
            return (
              <div>
                <FormFieldGenerator
                  fieldDefinition={{
                    "type": "input_checkbox",
                    "params": {
                      "label": question_checklist_title,
                      "name": _name,
                    }
                  }}
                  value={val}
                  formErrors={{}}
                  handleChange={(e) => { _handleChecklistChange(e, index) }}
                />
              </div>
            );
          })
        }
      </div>
    </div>
  );
};


// TODO
const ExtraAnswer = (props) => {
  const {
    question,
    title,
    name,
    value,
    extraAnswerValue,
    handleExtraAnswerChange,
    fieldValidationErrorExtra,
  } = props;
  const {
    question_type,
    extra_answer_enabled,
    extra_answer_condition,
  } = question;
  //
  let is_extra_answer = false;
  let jsx = null;
  if (_zzsurvey_utils_questions_lib_obj?.[question_type]?.has_extra_ansver === true) {
    if (extra_answer_enabled === true) {
      if (extra_answer_condition === null) {
        is_extra_answer = true;
      } else {
        if (extra_answer_condition === value) {
          is_extra_answer = true;
        }
      }
    }
  }
  console.log('question', question);
  console.log('is_extra_answer', is_extra_answer);
  if (is_extra_answer) {
    jsx = (
      <div className="zzsurvey__answer">
        <div className="zzsurvey__answer-extra">
          <div className="zzsurvey__answer__header">{title}</div>
          <FormError error={fieldValidationErrorExtra} />
          <FormFieldGenerator
            fieldDefinition={{
              "type": "input_text",
              "params": {
                "label": "extra answer",
                "name": name,
              }
            }}
            value={extraAnswerValue}
            handleChange={handleExtraAnswerChange}
          />
        </div>
      </div>
    );
  }
  //
  return (
    <>
      {jsx}
    </>
  );
};


//
const QuizSingleAnswer = (props) => {
  const {
    index,
    // item,
    // value,
    question,
    singleAnswerState,
    handleAnswerChange,
    handleExtraAnswerChange,
    fieldValidationError,
    fieldValidationErrorExtra,
  } = props;
  const {
    question_id,
    title,
    // answer,
    extra_question_title,
  } = question;
  const name = QUIZ_FIELD_NAME_PREFIX + question_id;
  const value = singleAnswerState.answer_main;
  const handleChange = handleAnswerChange;
  const name_extra = QUIZ_FIELD_NAME_PREFIX_EXTRA_ANSWER + question_id;
  const extraAnswerValue = singleAnswerState.answer_extra;
  // const [state, setState] = useState(answer);
  // const [stateArr, setStateArr] = useState([]);
  const pack = {
    index,
    question,
    title,
    name,
    value,
    handleChange,
    // fieldValidationError, // TODO
    // state,
    // setState,
    // stateArr,
    // setStateArr,
  };
  let jsx = null;
  if (question.question_type === 'TEXT') {
    jsx = (<AnswerText pack={pack} />);
  } else if (question.question_type === 'YES_NO') {
    jsx = (<AnswerYesNo pack={pack} />);
  } else if (question.question_type === 'STARS_5') {
    jsx = (<Answer5Stars pack={pack} />);
  } else if (question.question_type === 'SCALE_5') {
    jsx = (<AnswerScale5 pack={pack} />);
  } else if (question.question_type === 'ABC') {
    jsx = (<AnswerAbc pack={pack} />);
  } else if (question.question_type === 'CHECKLIST') {
    /*
    jsx = (
      <div>* CHECKLIST TODO</div>
    );
    */
    jsx = (
      <AnswerChecklist pack={pack} />
    );
  } else {
    jsx = (
      <div className="zzsurvey__editor__error-msg">ERROR Unknown question_type</div>
    );
  }
  //
  return (
    <>
      <div className="zzsurvey__card">
        <div className="zzsurvey__answer__header">{title}</div>
        <FormError error={fieldValidationError} />
        {jsx}
        <ExtraAnswer
          question={question}
          title={extra_question_title}
          name={name_extra}
          value={value}
          extraAnswerValue={extraAnswerValue}
          handleExtraAnswerChange={handleExtraAnswerChange}
          fieldValidationErrorExtra={fieldValidationErrorExtra}
        />
      </div>
    </>
  );
};


// DEFAULT COMPONENT
const ZZTempSurveyQuizFill = (props) => {
  const {
    mode,
    quiz_key,
    quizBlueprint,
    cbSubmit,
    // previewIsAnon={entity.is_anonymous}
  } = props;
  console.log('quiz_key', quiz_key);

  let initial_isAnon_state = false;
  if (mode === 'LIVE_PREVIEW') {
    if (typeof props.previewIsAnon === 'boolean') {
      initial_isAnon_state = props.previewIsAnon;
    }
  }

  const [isAnon, setIsAnon] = useState(initial_isAnon_state); // is_anonymous
  const [state, setState] = useState([]); // answers/filled state
  useEffect(() => {
    console.log('ZZTempSurveyQuizFill useEffect ... making new state');
    setState(_zzsurvey_utils_quizBlueprint_to_initialAnswersState(quizBlueprint, mode));
  }, [quizBlueprint, mode]);
  const [errors, setErrors] = useState({}); // state for input validation errors
  const [errorsExtra, setErrorsExtra] = useState({}); // state for input validation errors

  const handleAnswerChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const key = name.split(QUIZ_FIELD_NAME_PREFIX)[1];
    console.log('name', name, 'value', value, 'key', key);
    setState(state => {
      /*
      const oldAnswer = state[key];
      const updatedAnswer = {
        ...oldAnswer,
        answer_main: value,
      };
      return {
        ...state,
        [key]: updatedAnswer
      };
      */
      const updatedState = state.map((oldAnswer, index) => {
        const question_id = Number.parseInt(key);
        console.log('question_id', question_id, typeof question_id);
        console.log('oldAnswer', oldAnswer);
        if (oldAnswer.question_id === question_id) {
          const updatedAnswer = {
            ...oldAnswer,
            answer_main: value,
          };
          return updatedAnswer;
        } else {
          return oldAnswer;
        }
      });
      return updatedState;
    });
  };

  const handleExtraAnswerChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const key = name.split(QUIZ_FIELD_NAME_PREFIX_EXTRA_ANSWER)[1];
    console.log('name', name, 'value', value, 'key', key);
    setState(state => {
      /*
      const oldAnswer = state[key];
      const updatedAnswer = {
        ...oldAnswer,
        answer_extra: value,
      };
      return {
        ...state,
        [key]: updatedAnswer
      };
      */
      const updatedState = state.map((oldAnswer, index) => {
        const question_id = Number.parseInt(key);
        if (oldAnswer.question_id === question_id) {
          const updatedAnswer = {
            ...oldAnswer,
            answer_extra: value,
          };
          return updatedAnswer;
        } else {
          return oldAnswer;
        }
      });
      return updatedState;
    });
  };

  //
  const _answers_validator = (state) => {
    console.log('validator', state);
    let valid = true;
    let formErrors = {};
    let formErrorsExtra = {};
    //
    state.forEach((a, index) => {
      console.log(index);
      const question = a.q;
      const question_id = a.question_id;
      const answer = a.answer_main;
      const answer_extra = a.answer_extra;
      console.log(question);
      if (question.required === true) {
        // console.log('question.required', question.required, 'answer', answer);
        if (answer === null || typeof answer === 'undefined') {
          valid = false;
          formErrors[question_id] = 'This answer is required';
        }
      } else { // TODO
      }
      // if (question.extra_answer_required === true) {
      if (question.question_type !== 'TEXT' && question.extra_answer_enabled === true && question.extra_answer_required === true) {
        // console.log('question.required', question.required, 'answer', answer);
        if (!(typeof answer_extra === 'string' && answer_extra !== '')) {
          valid = false;
          formErrorsExtra[question_id] = 'This extra answer is required';
        }
      } else { // TODO
      }
    });
    //
    return {
      valid,
      formErrors,
      formErrorsExtra,
    }
  };

  const handleClickSubmit = (e) => {
    const entbox = _prepare_for_submit_answers(state, isAnon);
    console.log('data prepared for SUBMIT', entbox);
    const _validation_result = _answers_validator(state);
    console.log('_validation_result', _validation_result);
    if (_validation_result.valid === true) {
      if (typeof cbSubmit === 'function') {
        cbSubmit(quiz_key, entbox);
      }
      setErrors({});
      setErrorsExtra({});
    } else {
      window.alert('You must fill all required fields');
      console.log('formErrors',);
      console.log('formErrorsExtra', _validation_result.formErrors);
      console.log('formErrorsExtra', _validation_result.formErrorsExtra);
      setErrors(_validation_result.formErrors);
      setErrorsExtra(_validation_result.formErrorsExtra);
    }
  };

  // title='Submit your answers'
  // title='Pošalji odgovore'
  return (
    <>
      <div className="zzsurvey__quiz__bg-wrapper">
        <div className="zzsurvey__quiz__panel">
          <div className="zzsurvey__quiz__header">
            {
              quizBlueprint.survey_img_src && (
                <div className="zzsurvey__quiz__header__img"><img src={quizBlueprint.survey_img_src} /></div>
              )
            }
            <h1 className="zzsurvey__quiz__header__title">{quizBlueprint.title}</h1>
            <div className="zzsurvey__quiz__header__text">{quizBlueprint.survey_text}</div>
          </div>
          <div className="zzsurvey__quiz__body">
            <div className="zzsurvey__questions-vector">
              {
                state.map((singleAnswerState, index) => {
                  // Object.keys(state).map((key, index) => {
                  // const question_id = key;
                  // const singleAnswerState = state[question_id];
                  const key = singleAnswerState.question_id;
                  const fieldValidationError = errors[key];
                  const fieldValidationErrorExtra = errorsExtra[key];
                  return (
                    <QuizSingleAnswer
                      key={key}
                      index={index}
                      question={singleAnswerState.q}
                      singleAnswerState={singleAnswerState}
                      handleAnswerChange={handleAnswerChange}
                      handleExtraAnswerChange={handleExtraAnswerChange}
                      fieldValidationError={fieldValidationError}
                      fieldValidationErrorExtra={fieldValidationErrorExtra}
                    />
                  );
                })
              }
            </div>

          </div>
          <div className="zzsurvey__quiz__footer">
            <div>
              <FormFieldGenerator
                fieldDefinition={{
                  "type": "input_checkbox",
                  "params": {
                    // "label": "Remain anonymous",
                    "label": "Ostani anoniman",
                    "name": "is_anonymous",
                  }
                }}
                value={isAnon}
                handleChange={(e) => { setIsAnon(e.target.checked); }}
                fieldError={null}
              />
            </div>
            <div className="uu-gap-standalone-8px"></div>
            <Btn
              circle
              title='Pošalji odgovore'
              btnDialogSubmit
              handleClick={handleClickSubmit}
              disabled={false}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ZZTempSurveyQuizFill;